import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { LogLevel } from '../interfaces';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for stage view module related message requests.
 */
var StageViewMessageHandler = /** @class */ (function (_super) {
    __extends(StageViewMessageHandler, _super);
    function StageViewMessageHandler(appSdkHost, stageViewService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.stageViewService = stageViewService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    StageViewMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.stageView.open, function (_, stageViewParams) { return formulateSdkResponse(stageViewParams, _this.stageViewService.open); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.stageView.open, error, scenario); },
        });
    };
    StageViewMessageHandler.prototype.validateDependencies = function () {
        if (!this.stageViewService) {
            throw 'No stageViewService provided';
        }
    };
    return StageViewMessageHandler;
}(BaseMessageHandler));
export { StageViewMessageHandler };
var StageViewLegacyLinkHandler = /** @class */ (function () {
    function StageViewLegacyLinkHandler(stageViewService, logger) {
        this.stageViewService = stageViewService;
        this.logger = logger;
    }
    StageViewLegacyLinkHandler.prototype.tryGetDataFromLink = function (url) {
        var _a;
        if (!this.stageViewService) {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin) {
            return null;
        }
        var matches = url.pathname.match(StageViewLegacyLinkHandler.STAGE_VIEW_URL_REGEX);
        if (!matches) {
            return null;
        }
        var appId = matches[1];
        var context = url.searchParams.get('context');
        if (!context) {
            return null;
        }
        var openStageViewParams;
        try {
            openStageViewParams = JSON.parse(context);
        }
        catch (e) {
            // If there is an error parsing the URL, pass the url to openLink
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log(LogLevel.Error, 'StageViewLegacyLinkHandler', 'There is an error parsing the URL', e);
            return null;
        }
        var contentUrl = openStageViewParams.contentUrl;
        if (!contentUrl) {
            return null;
        }
        var title = openStageViewParams.title || undefined;
        var threadId = openStageViewParams.threadId || undefined;
        var websiteUrl = openStageViewParams.websiteUrl || undefined;
        var entityId = openStageViewParams.entityId || undefined;
        return {
            appId: appId,
            contentUrl: contentUrl,
            threadId: threadId,
            title: title,
            websiteUrl: websiteUrl,
            entityId: entityId,
        };
    };
    StageViewLegacyLinkHandler.prototype.executeData = function (data) {
        return this.stageViewService.open(data);
    };
    // This is looking for a URL with this pattern: "/l/stage/<app id>/0"
    StageViewLegacyLinkHandler.STAGE_VIEW_URL_REGEX = /^\/l\/stage\/([^\/]+)\/?0$/;
    return StageViewLegacyLinkHandler;
}());
export { StageViewLegacyLinkHandler };
//# sourceMappingURL=stageview-message-handler.js.map